"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audioVideoDidStopHandler = audioVideoDidStopHandler;
var _logger = require("@studio/logger");
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
var _constants = require("../../../constants");
function audioVideoDidStopHandler(sessionStatus, meetingSession, meetingResponse, attendeeResponse, hasLocalTile) {
  /*
  - You (or someone else) have called the DeleteMeeting API action in your server application.
  - You attempted to join a deleted meeting.
  - No audio connections are present in the meeting for more than five minutes.
  - Fewer than two audio connections are present in the meeting for more than 30 minutes.
  - Screen share viewer connections are inactive for more than 30 minutes.
  - The meeting time exceeds 24 hours.
  See https://docs.aws.amazon.com/chime/latest/dg/mtgs-sdk-mtgs.html for details.
  */

  // Log meeting ended
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  var logPayload = {
    chimeEventName: 'audioVideoDidStop',
    sessionStatusCode: sessionStatus.statusCode(),
    'studio.meeting.id': meetingId,
    title: sessionStatus.statusCode() === _amazonChimeSdkJs.MeetingSessionStatusCode.MeetingEnded ? "Meeting id: ".concat(meetingId, " ended by attendee: ").concat(attendeeId) : "chime:audioVideoDidStop received for attendee ".concat(attendeeId)
  };
  (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
  if (hasLocalTile) {
    meetingSession.deviceController.destroy();
  }
}